import React from "react";
import { DataTable } from "./DataTable";
import { Button, Upload } from "antd";
import { YhBox } from "@/components/YhBox";
import { useMaintenanceModel } from "../MaintenanceModel";
import useNavModel from "@/model/navModel";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { ResourcesAuthBtn } from "@/types/ResourcesAuthEnum";
import { mianCode } from "@/utils/constants";
import { formatNum } from "@/utils/utils";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
export const DataBox = () => {
    const { loadData, descTotal, selectedRowKeys, rowsDescTotal, maintenanceExport } = useMaintenanceModel();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const onEdit = () => {
        maintenanceExport()
    }
    const title = <Button
        className="mr-5"
        type="link"
        shape="round"
        onClick={onEdit}
    >{Locale["export"]}</Button>

    const desc: IDescription[] = [
        {
            // label: "工时费合计",
            label: Locale["Total Labor Cost"],
            value: selectedRowKeys.length === 0 ? descTotal.workingHoursAmount : formatNum(rowsDescTotal.workingHoursAmount),
            color: DescriptionColorEnum.red
        },
        {
            // label: "零件费合计",
            label: Locale["Total Material Cost"],
            value: selectedRowKeys.length === 0 ? descTotal.materialScienceAmount : formatNum(rowsDescTotal.materialScienceAmount),
            color: DescriptionColorEnum.red
        },
        {
            // label: "应收合计",
            label: Locale["Total Receivable Amount"],
            value: selectedRowKeys.length === 0 ? descTotal.receivableTotalAmount : formatNum(rowsDescTotal.receivableTotalAmount),
            color: DescriptionColorEnum.red
        },
        {
            // label: "已收合计",
            label: Locale["Total Received Amount"],
            value: selectedRowKeys.length === 0 ? descTotal.amountReceived : formatNum(rowsDescTotal.amountReceived),
            color: DescriptionColorEnum.red
        },
    ]
    return (
        <YhBox title={title} descriptions={desc}>
            <DataTable />
        </YhBox>
    )
}